var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHamburgerMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 13.0186C18.6642 13.0186 19 13.3543 19 13.7686C19 14.1828 18.6642 14.5186 18.25 14.5186L1.75 14.5186C1.33579 14.5186 1 14.1828 1 13.7686C1 13.3543 1.33579 13.0186 1.75 13.0186L18.25 13.0186ZM18.25 6.26855C18.6642 6.26855 19 6.60434 19 7.01855C19 7.43277 18.6642 7.76855 18.25 7.76855L1.75 7.76855C1.33579 7.76855 1 7.43277 1 7.01855C1 6.60434 1.33579 6.26855 1.75 6.26855L18.25 6.26855Z",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHamburgerMenu);
export default __webpack_public_path__ + "static/media/icon-hamburger-menu.66338b81360c9d80eaa061e0dfcc78a7.svg";
export { ForwardRef as ReactComponent };